/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class GeofencePhoneNumberValidator {
  static createValidator(): ValidatorFn {
    //valid ones : "5551234" or "(888) 555-1234 ,999 999 9999"
    const phonePattern = /^(([0-9]{1})*[\- .(]*([0-9a-zA-Z]{3})*[\- .)]*[0-9a-zA-Z]{3}[\- .]*[0-9a-zA-Z]{4})+$/;
    return (control: AbstractControl): ValidationErrors =>
      control.value?.trim() === '' || phonePattern.test(control.value) ? null : { invalidPhoneNumber: true };
  }
}
